<div class="medicine-dosage-types-list">
  <div class="mbp-table-wrap">
    <table mat-table matSort [dataSource]="medicineDosageTypes" class="mbp-data-table medicine-dosage-types-list__table">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="name-col">Name</th>
        <td mat-cell *matCellDef="let medicineDosageType" class="name-col">{{ medicineDosageType.additional_information }}</td>
      </ng-container>

      <ng-container matColumnDef="dosage_type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let medicineDosageType">{{ getDosageType(medicineDosageType) }}</td>
      </ng-container>

      <ng-container matColumnDef="created">
        <th mat-header-cell *matHeaderCellDef>Created</th>
        <td mat-cell *matCellDef="let medicineDosageType">{{ utilsService.formatTime(medicineDosageType.created_at) }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="actions-col">&nbsp;</th>
        <td mat-cell *matCellDef="let medicineDosageType" class="actions-col">
          <div class="medicine-dosage-types-list__actions">
            <button type="button" class="medicine-dosage-types-list__btn" color="primary" (click)="edit(medicineDosageType)" mat-stroked-button>
              <mat-icon>info</mat-icon> Details
            </button>

            @if (!medicineDosageType.is_active) {
              <button *authGroup="['SuperAdmin']" type="button" (click)="activate(medicineDosageType)" class="medicine-dosage-types-list__btn medicine-dosage-types-list__btn--primary" mat-flat-button color="primary">
                Activate
              </button>
            }

            @if (medicineDosageType.is_active) {
              <button *authGroup="['SuperAdmin']" type="button" (click)="deActivate(medicineDosageType)" class="medicine-dosage-types-list__btn medicine-dosage-types-list__btn--warn" mat-stroked-button>
                Deactivate
              </button>
            }

            @if (!perm.isViewer()) {
              <button type="button" class="medicine-dosage-types-list__btn medicine-dosage-types-list__btn--warn" (click)="delete(medicineDosageType)" mat-stroked-button>
                Delete
              </button>
            }
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <mat-paginator
    class="medicine-dosage-types-list__paginator"
    [length]="total"
    [pageSize]="limit"
    [pageIndex]="page - 1"
    [pageSizeOptions]="[5, 10, 20, 50]"
    (page)="onPageChange($event)">
  </mat-paginator>

  <div class="medicine-dosage-types-list__pager">
    <div class="medicine-dosage-types-list__pager-buttons">
      <button type="button" mat-stroked-button class="medicine-dosage-types-list__pager-btn" (click)="prevPage()" [disabled]="page <= 1">
        <mat-icon>chevron_left</mat-icon>
        Previous
      </button>
      <button type="button" mat-stroked-button class="medicine-dosage-types-list__pager-btn" (click)="nextPage()" [disabled]="page >= lastPage">
        Next
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
    <span class="medicine-dosage-types-list__pager-label">Page {{ page }} of {{ lastPage }}</span>
  </div>
</div>
